// extracted by mini-css-extract-plugin
module.exports = {"heading":"contact_heading_2MAuP","content":"contact_content_z-29H","map":"contact_map_2BpIC","text":"contact_text_3oxf9","officeName":"contact_officeName_21zi0"};